import { ContractDocument, CombinedTier } from 'shared/types';

export type CustomerNotificationTemplate = 'delete' | 'restore' | 'approve' | 'reject';
export interface CustomerManagementGridItem {
  id: string;
  masterCustomer: string;
  abgBrand: string;
  channel: string;
  lastTwelveMonthRevenue: number;
  customerTier: string;
  numberOfSkus: number;
  grossToNetPercent: number;
  numberOfContracts: number;
  pricingType: string;
  priceList: string;
  isMarkedForDeletion: boolean;
  isDeleted: boolean;
}

export interface CustomerContractSummaryGrossNetGridItem {
  id: string;
  originalDocumentName: string;
  brand: string;
  ltmRevenue: number;
  allowances: number;
  coop: number;
  discounts: number;
  other: number;
  paymentTerms: number;
  rebates: number;
}

export interface CustomerContractSummaryGrossNetDollarsGridItem extends CustomerContractSummaryGrossNetGridItem {}

export interface CustomerContractSummaryGrossNetPercentGridItem extends CustomerContractSummaryGrossNetGridItem {}

export type CustomerContractInventoryGridItem = Pick<
  ContractDocument,
  | 'id'
  | 'brand'
  | 'status'
  | 'approvalStatus'
  | 'originalDocumentName'
  | 'billToCode'
  | 'startDate'
  | 'endDate'
  | 'customerName'
  | 'deletedAt'
  | 'deletedBy'
>;

export interface CustomerProductPricesDTO {
  id: string;
  brand: string;
  sku: string;
  productDescription: string;
  productDescription2: string;
  shape: string;
  finish: string;
  lastTwelveMonthRevenue: number;
  currentPrice: number;
  oldPrice: number;
  effectiveDate: string;
  pricingMethod: string;
  customerName: string;
  channel: string;
  revTier: string;
  listPrice: number;
  recommendedPrice: number;
  lastTwelveMonthQuantity: number;
  estimatedImpact: number;
  status: string;
}

export interface ViewContractsContractTermsSummaryGridItem {
  id: string;
  brand: string;
  paymentNet: string;
  paymentTerms: string;
  volumeRebate: string;
  coop: string;
  metMst: string;
  defectiveAllowance: string;
  commission: string;
  tradeDiscount: string;
}

export interface ViewContractsTiersGridItem extends CombinedTier {}

export type CustomerFilter = Pick<
  CustomerManagementGridItem,
  'abgBrand' | 'customerTier' | 'masterCustomer' | 'channel'
>;

export const defaultCustomerFilters: CustomerFilter = {
  abgBrand: '',
  customerTier: '',
  masterCustomer: '',
  channel: '',
};
